export default __webpack_public_path__ + "static/media/ad-creator.460059e1.svg";